import React, { useState } from 'react';
import { Card } from '@repo/ui/Card';
import { gql } from '@apollo/client';
import { useApolloClient } from '@apollo/client/react';
import { Button } from '@repo/ui/Button';
import { useZodForm } from '@repo/hooks/useZodForm';
import { useNavigate } from 'react-router';

import { DeleteDialog } from '@repo/ui/Dialog';
import { Form } from '@repo/ui/Form';

export interface DeactivateSubAccountProps {
  name: string;
  notes?: string;
  loading: boolean;
  subAccountId: string;
  accountId: string | string[] | undefined;
}

const DeactivateSubAccount = ({
  name,
  notes,
  loading,
  subAccountId,
  accountId,
}: DeactivateSubAccountProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const DEACTIVATE_SUB_ACCOUNT = gql`
    mutation DeactivateSubAccount($id: ID!) {
      deactivateAccount(id: $id) {
        account {
          id
        }
      }
    }
  `;

  const client = useApolloClient();
  const onSubmit = async () => {
    setIsOpen(false);
    await client.mutate({
      mutation: DEACTIVATE_SUB_ACCOUNT,
      variables: {
        id: subAccountId,
      },
    });
    setTimeout(() => {
      navigate(`/a/${accountId}/sub-accounts`);
    }, 2000);
  };

  const form = useZodForm({
    onSubmit,
  });

  return (
    <>
      <Card title="Deactivate sub account">
        <Button loading={loading} variant="danger" onClick={() => setIsOpen(true)}>
          Deactivate sub account
        </Button>
      </Card>

      <DeleteDialog
        title={`Are you sure you want to deactivate this sub account?`}
        setIsOpen={setIsOpen}
        isOpen={isOpen}
        centered
        form={form}
        submitText="Yes, deactivate sub account"
        cancelText="No, abort"
      >
        <Form.Success>Sub account successfully deactivated.</Form.Success>
        <Form.Error>
          Unable to deactivate sub account. Please try again later or contact support if error
          persists.
        </Form.Error>
        <div className="text-center flex flex-col w-full gap-2 sm:col-span-2  py-3 border border-l-0 border-r-0 mb-7 border-grey-400/50">
          <span className="text-2xl font-bold">{name}</span>
          <span>ID: {subAccountId}</span>
          <span>Description: {notes}</span>
        </div>
      </DeleteDialog>
    </>
  );
};

export default DeactivateSubAccount;
